<div class="global-loader" *ngIf="isLoading">
    <div class="global-backdrop"></div>

    <div class="global-spinner">
        <div class="three-dots">
            <span></span>
            <span></span>
            <span></span>
        </div>
    </div>
</div>